import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { DiscordProvider } from "@/context/DiscordContext";
import Navbar from "@/components/site/Navbar";
import AnnouncementBar from "@/components/site/AnnouncementBar";
import Hero from "@/components/site/Hero";
import Features from "@/components/site/Features";
import Lore from "@/components/site/Lore";
import FeaturedPhoto from "@/components/site/FeaturedPhoto";
import Footer from "@/components/site/Footer";
import ScrollManager from "@/components/site/ScrollManager";
import SmoothScroll from "@/components/site/SmoothScroll";
import PageWrap from "@/components/site/PageWrap";
import RulesPage from "@/pages/RulesPage";
import GuidePage from "@/pages/GuidePage";
import ApplyPage from "@/pages/ApplyPage";
import AdminPage from "@/pages/AdminPage";
import MembersPage from "@/pages/MembersPage";
import MemberEditPage from "@/pages/MemberEditPage";
import ModTrackerPage from "@/pages/ModTrackerPage";
import MediaPage from "@/pages/MediaPage";
import MusicPlayer from "@/components/site/MusicPlayer";
import SignalLost from "@/components/site/SignalLost";

function HomePage() {
  return (
    <PageWrap>
      <div className="App min-h-screen">
        <Navbar />
        <AnnouncementBar />
        <main>
          <Hero />
          <Features />
          <FeaturedPhoto />
          <Lore />
        </main>
        <Footer />
      </div>
    </PageWrap>
  );
}

function App() {
  return (
    <DiscordProvider>
      <BrowserRouter>
        <SmoothScroll />
        <ScrollManager />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/rules" element={<PageWrap><RulesPage /></PageWrap>} />
          <Route path="/guide" element={<PageWrap><GuidePage /></PageWrap>} />
          <Route path="/apply" element={<PageWrap><ApplyPage /></PageWrap>} />
          <Route path="/admin" element={<PageWrap><AdminPage /></PageWrap>} />
          <Route path="/members" element={<PageWrap><MembersPage /></PageWrap>} />
          <Route path="/members/me" element={<PageWrap><MemberEditPage /></PageWrap>} />
          <Route path="/modtracker" element={<PageWrap><ModTrackerPage /></PageWrap>} />
          <Route path="/media" element={<PageWrap><MediaPage /></PageWrap>} />
        </Routes>
        <MusicPlayer />
        <SignalLost />
      </BrowserRouter>
      <Toaster
        position="bottom-right"
        theme="dark"
        toastOptions={{
          style: {
            background: "#161D14",
            border: "1px solid #283524",
            color: "#E2E4DF",
            borderRadius: 0,
            fontFamily: "JetBrains Mono, monospace",
            fontSize: "12px",
            letterSpacing: "0.05em",
          },
        }}
      />
    </DiscordProvider>
  );
}

export default App;
